import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import * as actions from '../../redux/actions';
import FieldAllowanceApprovalTable from '../../components/Table/FieldAllowanceApprovalTable';
import { confirmAsync } from '../../utils/functions/globalDialog';
import { canApproveByCategory } from '../../utils/functions/approverAccess';

export default function FieldAllowanceRequest({ title, subtitle }) {
  const dispatch = useDispatch();
  const faRequestOrder = useSelector((state) => state.fieldAllowanceRequestOrder);
  const me = useSelector((state) => state.me);
  const info = useSelector((state) => state.info);
  const canApprove = canApproveByCategory(me, info, 'field_allowance_approver', '/humen/field-allowance-request');

  const [page, setPage] = useState(1);
  const [size] = useState(50);

  useEffect(() => {
    dispatch(actions.fieldAllowanceRequestOrderAll({ size, page }));
    return () => {};
  }, [page, size]);

  useEffect(() => {
    dispatch(actions.meGet());
    dispatch(actions.getInformation({}));
    return () => {};
  }, []);

  const refresh = () => dispatch(actions.fieldAllowanceRequestOrderAll({ size, page }));

  const handleApprove = async (id, approvedEmployeeIds) => {
    await dispatch(actions.fieldAllowanceRequestOrderPut(id, {
      status: 'APPROVED',
      status_approve: { approve: true, approver: me?.userData?.id },
      approvedEmployeeIds,
    }));
    refresh();
  };

  const handleReject = async (id) => {
    const confirm = await confirmAsync('ยืนยันปฏิเสธคำขอนี้ทั้งชุดใช่หรือไม่?');
    if (!confirm) return;
    await dispatch(actions.fieldAllowanceRequestOrderPut(id, {
      status: 'REJECTED',
      status_approve: { approve: true, approver: me?.userData?.id },
    }));
    refresh();
  };

  return (
    <div>
      <FieldAllowanceApprovalTable
        faRequestOrder={faRequestOrder}
        onApprove={handleApprove}
        onReject={handleReject}
        canApprove={canApprove}
      />
    </div>
  );
}
